import { render, staticRenderFns } from "./admin_ssjs.vue?vue&type=template&id=49efbe7b&scoped=true"
import script from "./admin_ssjs.vue?vue&type=script&lang=js"
export * from "./admin_ssjs.vue?vue&type=script&lang=js"
import style0 from "./admin_ssjs.vue?vue&type=style&index=0&id=49efbe7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49efbe7b",
  null
  
)

export default component.exports